import { Component, OnInit, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { Http } from '@angular/http';
import * as moment from 'moment/moment';
declare  const $;
import {CsvService} from 'angular2-json2csv';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { DialogService,DialogComponent} from 'ng2-bootstrap-modal';
import {AlertHistoryComponent} from '../alert-history/alert-history.component';
import { Popup } from 'ng2-opd-popup';
import { IOption } from 'ng-select';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-service-due-report',
  templateUrl: './service-due-report.component.html',
  styleUrls: ['./service-due-report.component.scss']
})

export class ServiceDueReportComponent implements OnInit {
	customerNameDropDown:Array<IOption>=[];
	CUSTOMERNAMEplaceholder:string="CUSTOMER NAME";
	SerialNumberDropDown:Array<IOption>=[];
	PmaCategoryDropdown:Array<IOption>=[];
	SERIALNUMBERplaceholder:string="SERIAL NUMBER";
	MakeDropDown:Array<IOption>=[];
	ModelDropDown:Array<IOption>=[];
	MAKEplaceholder:string="MAKE";
	MODELplaceholder:string="MODEL";
	ListAllHistroyDetails=[];
	finalArr=[];
	listContractLevel=[];
	AllMakedetails=[];
	AllModalDetails=[];
	fromDate:any;
	toDate:any;
  	listSearchData:any[] = [];
  	date:any;
  	CustomerName:any;
  	Location:any;
  	Make:any;
  	Model:any;
		MechineSerialNumber:any;
		PmaCategoryy:any="";
  	ServiceType:any;
  	Labour:any;
  	Spares:any;
	Travel:any;
	ListOfCustomerMaster:any[] = [];
	customerDetails:any[] = [];
	Response:any[] = [];
	ListOfCheckListMaster:any[] = [];
	startingCount:number = 0;
	endingCount:number = 0;
	p: number = 1;
	histroy:any[]=[];
  	clientName:any;
  	serialNumber:any;
  	mcLocation:any;
  	phoneNumber:any;
  	email:any;
  	make:any;
  	model:any;
  	hmrHours:any;
  	technicianName:any;
  	lastServiceType:any;
  	lastServiceHours:any;
  	yearOfManufacture:any;
  	branch:any;
  	serviceContractOfferedYear:any;
  	contractReference:any;
  	noofServiceContractYears:any;
  	startDate:any;
  	endDate:any;
  	noOfservice:any;
  	serviceRemainderDays:any;
  	currentService:any;	
	ListserviceDetails:any;
	histroyPP:any[] = [];
	reqmodelId;
 	reqMakeId;
 	ListAllMake = [];
 	ListAllModel = [];
 	ListAllServcieType = [];
  	@ViewChild('Histroy') Histroy: Popup;
  	ServiceContractExtend = [];
  	histroyPr = [];
  	ListTechnicianName = [];
  	techinicianDetails = [];
  	errformdate:boolean=false;
	errtodate:boolean=false;
	public searchBytext:boolean=false;
	orgId:number;
  	userId:number;
  	CSconfig2: any = {'placeholder': 'CUSTOMER NAME', 'sourceField': ['customer_Name']};
	SNconfig2: any = {'placeholder': 'SERIAL NUMBER', 'sourceField': ['serial_Number']};
	config2MK: any = {'placeholder': 'MAKE', 'sourceField': ['make']};
	config2MD: any = {'placeholder': 'MODEL', 'sourceField': ['model']}; 
	ListOfSerialNumber = [];
	customerName: any;
	serialnumber: any;
	smake: any;
	smodel: any;
	clientId:any;
	localArrValue = [];
	loading:boolean=false;
	ListbranchDetails:any[]=[];
	ListPmaCategoryDetails:any[]=[];
	constructor(private dialogservice:DialogService,private http: Http,private csvService: CsvService,private router:Router,private route : ActivatedRoute) { }

	ngOnInit():void {
		
		this.loading=true;
		if(this.route.params['value'].orgId === '' || this.route.params['value'].orgId === undefined || this.route.params['value'].orgId === null || this.route.params['value'].userId === undefined || this.route.params['value'].userId === '' || this.route.params['value'].userId === null){
	      window.location.href = 'https://still.alshirawi.com/highmessaging/';
	    } else {
		    this.orgId=this.route.params['value'].orgId;
		    this.userId=this.route.params['value'].userId;
		    console.log('OrgId '+ this.orgId);
		    console.log('UserId '+ this.userId);
		    var date = new Date(), y = date.getFullYear(), m = date.getMonth();
			let firstDay = new Date(y, m, 1);
			let lastDay = new Date(y, m + 1, 0);
			let firstDate = moment(firstDay).format('YYYY-MM-DD');
			let lastDate = moment(lastDay).format('YYYY-MM-DD');
			this.fromDate = moment(firstDay).format('YYYY-MM-DD');
			this.toDate = moment(lastDay).format('YYYY-MM-DD');
			this.search();
			this.getAllserialNumberDetails();
			this.getTechnicianName();
			this.getmakedetailsforhistory();
			this.getmodeldetailsforhistory();

	  	}
	}

	onSelectCS(val: string) {
	}

	onInputChangedEventCS(val: string) {
	}

	onInputChangedEventSN(val: string) {
	}

	onSelectSN(val: string) {
	}

	onInputChangedEventMK(val: string) {
	}

	onSelectMK(val: string) {
	}

	onInputChangedEventMD(val: string) {
	}

	onSelectMD(val: string) {
	}

	getAllserialNumberDetails() {
        //this.spinner.show();
        let PMSObj = {
        	'orgId':this.orgId
        }
        return this.http.post('/api/getAllPreventiveMaintenanceDetails', PMSObj).subscribe(
            res => {
            //this.spinner.hide();
						this.ListOfSerialNumber = res.json();
						let pusharr=[];
						for(let i=0;i<this.ListOfSerialNumber.length;i++){
			  		 pusharr.push({'value':this.ListOfSerialNumber[i]._id.toString(),'label':this.ListOfSerialNumber[i].serial_Number.toUpperCase()})

							}
						  this.SerialNumberDropDown=pusharr;
        })
    }

    showAlert(){
	
		console.log("ListAllHistroyDetails",this.ListAllHistroyDetails)
		this.dialogservice.addDialog(AlertHistoryComponent,{title:'View History',values:this.ListAllHistroyDetails,contractlevelArr:this.listContractLevel,'finalArr':this.finalArr,'customIndex':0})
		// this.dialogservice.addDialog(AlertHistoryComponent,{title:'View History',clientName:this.clientName,
		// 	HMRHours:this.hmrHours,ContractReference:this.contractReference,
		// 	SerialNumber:this.serialNumber,TechnicianName:this.technicianName,NoOfServiceContractYears:this.noofServiceContractYears
		// 	,MCLocation:this.mcLocation,LastSerivceType:this.lastServiceType,StartDate:this.startDate,PhoneNumber:this.phoneNumber
		// 	,LastServiceHours:this.lastServiceHours,EndDate:this.endDate,
		// 	Email:this.email,YearOfManufacture:this.yearOfManufacture,noOfservice:this.noOfservice,
		// 	Make:this.make,Branch:this.branch,ServiceRemainderDay:this.serviceRemainderDays,Modal:this.model,
		// 	ServiceContractOfferedYear:this.serviceContractOfferedYear,
		// 	currentService:this.currentService,histroyPP:this.histroyPP,ListserviceDetails:this.ListserviceDetails,histroyPr:this.histroyPr
		// 	,ServiceContractExtend:this.ServiceContractExtend});
		// this.dialogservice.addDialog(AlertHistoryComponent,{title:this.Getmessage,message:"adasSSSSSSSSS"})
	}
	
	exportToExcel(event) {
		// let Reportstartdate = moment(this.fromDate).format('D MMM YYYY');
		// let Reportenddate = moment(this.toDate).format('D MMM YYYY');
		// this.csvService.download(this.listSearchData,Reportstartdate+ 'to'+ Reportenddate+ 'Service Due Report');

		let	data=[];
		let Reportstartdate = moment(this.fromDate).format('D MMM YYYY');
		let Reportenddate = moment(this.toDate).format('D MMM YYYY');
		let title=Reportstartdate+' '+'to'+' '+ Reportenddate+' '+'Service Due Report.xlsx'
		data.push([Reportstartdate+' '+'to'+' '+ Reportenddate+' '+'SERVICE DUE REPORT'])
		data.push([])
		data.push(['S NO',"DATE",'SERIAL NUMBER','CLIENT NAME','PMA CATEGORY','MCLOCATION',"MAKE","MODEL","SERVICE TYPE","HMR","CONTRACT REFERENCE",'CONTACT NUMBER',"CONTRACT LEVEL","SERVICE NUMBER","CONSUMABLES","LABOUR COST","TRAVEL COST","SPARES COST","TOTAL COST"])
		for(let i=0;i<this.listSearchData.length;i++) {
		data.push([i+1,this.listSearchData[i].date,this.listSearchData[i].SerialNumber,this.listSearchData[i].ClientName,this.listSearchData[i].PmaCategory,this.listSearchData[i].MCLocation,this.listSearchData[i].Make,this.listSearchData[i].model,this.listSearchData[i].ServiceType,this.listSearchData[i].hmr,this.listSearchData[i].contactreference,this.listSearchData[i].contactNumber,this.listSearchData[i].contractLevel,this.listSearchData[i].serviceNumber,this.listSearchData[i].Consumables,this.listSearchData[i].labourCost,this.listSearchData[i].travelCost,this.listSearchData[i].SparesCost,this.listSearchData[i].total])
		}
		let wb: XLSX.WorkBook =XLSX.utils.book_new();
		const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(data);

		XLSX.utils.book_append_sheet(wb, ws,'Service Due Report');
		XLSX.writeFile(wb,title); 
	}

	
	getAllPmaCategorydetails () {
		//this.getlabourcostdetails();
		let makeObj = {
			'orgId':this.orgId
		}
	    return this.http.post('/api/getPmaCategorydetails', makeObj).subscribe(
	    res => {
     
	      let ResponePmaCategory = res.json();
			  
			  if(ResponePmaCategory.length>0){
		
          this.ListPmaCategoryDetails = ResponePmaCategory;
          let pusharr=[]
          for(let i=0;i<this.ListPmaCategoryDetails.length;i++){
            pusharr.push({'value':this.ListPmaCategoryDetails[i].pmacategory.toString(),'label':this.ListPmaCategoryDetails[i].pmacategory.toUpperCase()})
          }
          this.PmaCategoryDropdown=pusharr;
        
          console.log(this.ListPmaCategoryDetails);
		  	}else{
				this.loading=false;
			  }

	    },(err) =>{
				this.loading=false;
	      if(err.status != 200){
	     alert("Unable to load the value");
	      }
	    })
		}



	getAllMakeDetails() {
		let reqmakeObj = { 
			'orgId':this.orgId
		}
	    return this.http.post('/api/getMakedetails', reqmakeObj).subscribe(
        res => {
					 this.ListAllMake = res.json();
					 let pusharr=[];
					 for(let i=0;i<this.ListAllMake.length;i++){
						pusharr.push({'value':this.ListAllMake[i]._id.toString(),'label':this.ListAllMake[i].make.toUpperCase()})
		 
					 }
					 this.MakeDropDown=pusharr;
        },(err)=>{
       		alert('unable to load make values')
        })
	}

	getAllModelDetails() {
		let reqmodelObj = { 
			'orgId':this.orgId
		}
	    return this.http.post('/api/getAllModeldetails', reqmodelObj).subscribe(
        res => {
					 this.ListAllModel = res.json();
					 let pusharr=[];
					 for(let i=0;i<this.ListAllModel.length;i++){
						pusharr.push({'value':this.ListAllModel[i]._id.toString(),'label':this.ListAllModel[i].model.toUpperCase()})
					 }
					 this.ModelDropDown=pusharr;
        },(err)=>{
       		alert('unable to load make values')
        })
	}
	getAllServiceTypeDetails() {
		let reqServiceTypeObj = { 
			'orgId':this.orgId
		}
	    return this.http.post('/api/getServiceTypedetails', reqServiceTypeObj).subscribe(
        res => {
       		this.ListAllServcieType = res.json();
        },(err)=>{
       		alert('unable to load make values')
        })
	}

	getmodeldetailsforhistory() {
		// this.loading=true;
			 let modelObj = {
				 'orgId':this.orgId
			 }
			 return this.http.post('/api/getModelDetails', modelObj).subscribe(
				res => {
			
					this.AllModalDetails = [];
					let response = res.json();
					if(response.length>0) {
						this.AllModalDetails =response;
						//this.model = response[0].model.toUpperCase();;
					}
				},(err)=>{
					this.loading=false;
				//	this.spinner.hide();
				})
		 }

	getmodeldetails() {
      let modelObj = {
        'modelId':this.reqmodelId,
        'orgId':this.orgId
      }
      return this.http.post('/api/getModeldetailsBasedOnId', modelObj).subscribe(
       res => {
				 let response = res.json();
				
				 if(response.length>0) {
				
					this.model = response[0].model.toUpperCase();;
				}
       })
    }


		getmakedetailsforhistory() {
  
      let makeObj = {
        'orgId':this.orgId
      }
      return this.http.post('/api/getMakedetails', makeObj).subscribe(
       res => {
         
         this.AllMakedetails=[];
         let response = res.json();
         if(response.length>0) {
           this.AllMakedetails = response;
           
         }
       },(err)=>{
         this.loading=false;
        // this.spinner.hide();
       })
    }

    getmakedetails() {
      let makeObj = {
        'makeId':this.reqMakeId,
        'orgId':this.orgId
      }
      return this.http.post('/api/getMakedetailsBasedOnId', makeObj).subscribe(
       res => {
				 
				 let response = res.json();
				
         if(response.length>0) {
           this.make = response[0].make.toUpperCase();;
         }
       })
    }

    todatechange(date) {
    	if(this.toDate == "" || this.toDate == undefined || this.toDate == null) {
    		this.errtodate = true;
    	} else {
    		this.errtodate = false;
    		if(date < this.fromDate) {
	    		alert('To date should be greater than From Date');
	    		this.toDate = '';
	    	}
    	}
    	
    }

    getTechnicianName() {
    	let techObj = {
        'orgId':this.orgId
      	}
		return this.http.post('/api/getTechniciansName', techObj).subscribe(
	    res => {
        	res.json();
	    	this.ListTechnicianName = res.json();
	        let technicianArr = []
	        for(var i=0;i<this.ListTechnicianName.length;i++) {
	          let obj = {
	            'label':this.ListTechnicianName[i].FIRST_NAME +' '+ this.ListTechnicianName[i].LAST_NAME,
	            'value':this.ListTechnicianName[i].ID
	          }
	          technicianArr.push(obj);
	        }
	        this.techinicianDetails = technicianArr;
		})
	}

	viewHistory(pmId, serialNumber) {
		let ReqObjValue = {
			'pmId':pmId
		}
		return this.http.post('/api/getHistoryDetailsBasedOnContractLevel', ReqObjValue).subscribe(
    	res=>{ 
				
				this.histroy = res.json();
				this.clientName="";
			this.technicianName="";
			this.lastServiceType = "";
				this.ListAllHistroyDetails = [];
        this.listContractLevel=[];
				this.finalArr=[];
			
		
				for(let h=0;h<this.histroy.length;h++) {
          for(var k =0;k<this.customerDetails.length;k++) {
              if( this.histroy[0].client_Name == this.customerDetails[k].Id){
                this.clientName = this.customerDetails[k].Name
              }
            }
            //this.extensionUpdateId = this.histroy[h]._id
            for(let m=0;m<this.AllMakedetails.length;m++ ) {
              if(this.AllMakedetails[m]._id == parseInt(this.histroy[h].make)) {
								
                this.make = this.AllMakedetails[m].make;
              }
            }


						for(let n=0;n<this.ListbranchDetails.length;n++){
							if(this.ListbranchDetails[n]._id==this.histroy[h].branch){
							 this.histroy[h].branch=this.ListbranchDetails[n].branchAlias
							}
						}

            for(let md=0;md<this.AllModalDetails.length;md++ ) {
              if(this.AllModalDetails[md]._id == parseInt(this.histroy[h].model)) {
                this.model = this.AllModalDetails[md].model;
              }
            }
            for(let t=0;t<this.techinicianDetails.length;t++) {
              if(this.techinicianDetails[t].value == parseInt(this.histroy[h].technician_Name)) {
                this.technicianName = this.techinicianDetails[t].label;
              }
            }
            for(let ls=0;ls<this.ListAllServcieType.length;ls++) {
              if(this.ListAllServcieType[ls]._id == parseInt(this.histroy[h].last_Service_Type)) {
              			  this.lastServiceType = this.ListAllServcieType[ls].servicetype;
               }
			}
						

			if((this.lastServiceType==undefined||this.lastServiceType=="")&&this.histroy[h].last_Service_Type=="New Vehicle"){
						this.lastServiceType="New Vehicle"
				}
                      
              for(let i=0;i<this.histroy[h].Servicedetails.length;i++) {
                    for(let k=0;k<this.ListAllServcieType.length;k++) {
                          if(parseInt(this.histroy[h].Servicedetails[i].service_Type) ==this.ListAllServcieType[k]._id) {
                                this.histroy[h].Servicedetails[i].service_Type = this.ListAllServcieType[k].servicetype;
                        }
                 }
              
            }
            let histroyObject = {
			  'clientName':this.clientName,
			  'pmId':this.histroy[h]._id,
              'serialNumber':this.histroy[h].serial_Number,
              'mcLocation':this.histroy[h].mcLocation,
              'phoneNumber':this.histroy[h].phone_Number,
              'email':this.histroy[h].email,
              'make':this.make,
              'modal':this.model,
              'hmr':this.histroy[h].hmr,
              'contractLevel':this.histroy[h].contractLevel,
              'technicianName':this.technicianName,
              'lastserviceType':this.lastServiceType,
              'lastServiceHours':this.histroy[h].last_Service_Hours,
              'yearOfManufacturer':this.histroy[h].year_Of_manufacturer,
              'branch':this.histroy[h].branch,
              'contractRefernce':this.histroy[h].contract_Reference,
              'noofServiceContractYears':this.histroy[h].noofServiceContractYear,
              'startDate':moment(this.histroy[h].start_Date).format("D MMM YYYY"),
              'endDate':moment(this.histroy[h].end_Date).format("D MMM YYYY"),
              'newstartdate':this.histroy[h].start_Date,
              'newenddate':this.histroy[h].end_Date,
              'noOfservice':this.histroy[h].no_Of_Service,
              'serviceRemainderDays':this.histroy[h].remainderday,
              'currentService':this.histroy[h].serviceScheduleDay,
			  'ListserviceDetails': this.histroy[h].Servicedetails,
			  'lastServiceStatusOfContract':'',
              'histroyPr':[],
              'histroyPp':[],
              'ServiceContractExtend':[]

            }
            let clObj = {
              'contractLevel':this.histroy[h].contractLevel
            }
            //this.listContractLevel.push(clObj);
            this.ListAllHistroyDetails.push(histroyObject);
            //this.showAlert();
        } //histroy for loop end here



    	// 	for(var k =0;k<this.customerDetails.length;k++) {
	    //   		if( this.histroy[0].client_Name == this.customerDetails[k].Id){
	    //   			this.clientName = this.customerDetails[k].Name
	    //   		}
	    //   	}
    		
			// this.serialNumber = this.histroy[0].serial_Number;
			// this.mcLocation = this.histroy[0].mcLocation;
			// this.phoneNumber = this.histroy[0].phone_Number;
			// this.email = this.histroy[0].email;
			// this.reqMakeId = this.histroy[0].make;
	    //     this.getmakedetails();
	    //     this.reqmodelId = this.histroy[0].model;
	    //     this.getmodeldetails();
			// this.hmrHours = this.histroy[0].hmr;
			// for(let t=0;t<this.techinicianDetails.length;t++) {
			// 	if(this.techinicianDetails[t].value == parseInt(this.histroy[0].technician_Name)) {
			// 		this.technicianName = this.techinicianDetails[t].label;
			// 	}
			// }


			// for(let ls=0;ls<this.ListAllServcieType.length;ls++) {
			//     if(this.ListAllServcieType[ls]._id == parseInt(this.histroy[0].last_Service_Type)) {
			//     	this.lastServiceType = this.ListAllServcieType[ls].servicetype;
			//     }
			// }
			// if(this.lastServiceType==undefined && this.histroy[0].last_Service_Type=="New Vehicle"){
			//     this.lastServiceType="New Vehicle"
			// }

			
			// this.lastServiceHours = this.histroy[0].last_Service_Hours;
			// this.yearOfManufacture = this.histroy[0].year_Of_manufacturer;
			// this.branch = this.histroy[0].branch;
			// this.serviceContractOfferedYear = this.histroy[0].service_Contract_Offered;
			// this.contractReference = this.histroy[0].contract_Reference;
			// this.noofServiceContractYears = this.histroy[0].noofServiceContractYear;
			// this.startDate = this.histroy[0].start_Date;
			// this.endDate = this.histroy[0].end_Date;
			// this.noOfservice = this.histroy[0].no_Of_Service;
			// this.serviceRemainderDays = this.histroy[0].remainderday;
			// this.currentService = this.histroy[0].serviceScheduleDay;
			// for(let i=0;i<this.histroy[0].Servicedetails.length;i++) {
			// 	for(let k=0;k<this.ListAllServcieType.length;k++) {
			// 		if(parseInt(this.histroy[0].Servicedetails[i].service_Type) == this.ListAllServcieType[k]._id) {
			// 			this.histroy[0].Servicedetails[i].service_Type = this.ListAllServcieType[k].servicetype;
			// 		}
			// 	}
				
			// }
			// this.ListserviceDetails = this.histroy[0].Servicedetails;
			
    		let reqObj = {
	          'serialNumber':serialNumber,
	        }
	        return this.http.post('/api/getListAllPostPonedHistroy', reqObj).subscribe(
	        res=>{ 
	          
	          let ppHis = res.json();
	           this.histroyPP = [];
	           this.histroyPr = [];
	           if(ppHis.length>0) {
	            for(var p=0;p<ppHis.length;p++) {
	              if(ppHis[p].type == 'servicePrepone') {
	                let pphis = {
	                  'serialNumber':ppHis[p].serialNumber,
	                  'postPoned_Taken_Date':moment(ppHis[p].postPoned_Taken_Date,).format("D MMM YYYY"),
	                  'postPoned_Remainder_Days':ppHis[p].postPoned_Remainder_Days,
	                  'schedularNumber':ppHis[p].schedularNumber
	                }
									this.histroyPr.push(pphis);
									for(let pr=0;pr<this.ListAllHistroyDetails.length;pr++) {
										if(this.ListAllHistroyDetails[pr].serialNumber == ppHis[p].serialNumber && this.ListAllHistroyDetails[pr].contractLevel == ppHis[p].contractLevel) {
											this.ListAllHistroyDetails[pr].histroyPr = this.histroyPr;
										}
									} //for loop end here
	              } else if(ppHis[p].type == 'servicePostpone') {
	                let pphis = {
	                  'serialNumber':ppHis[p].serialNumber,
	                  'postPoned_Taken_Date':moment(ppHis[p].postPoned_Taken_Date,).format("D MMM YYYY"),
	                  'postPoned_Remainder_Days':ppHis[p].postPoned_Remainder_Days,
	                  'schedularNumber':ppHis[p].schedularNumber
	                }
									this.histroyPP.push(pphis);
									for(let pp=0;pp<this.ListAllHistroyDetails.length;pp++) {
										if(this.ListAllHistroyDetails[pp].serialNumber == ppHis[p].serialNumber && this.ListAllHistroyDetails[pp].contractLevel == ppHis[p].contractLevel) {
											this.ListAllHistroyDetails[pp].histroyPp = this.histroyPP;
										}
									} //for loop end here
	              }
	              
	              
	              
	            }
	          }
	          
	          let reqExtendobj = {
	            'serialNumber':serialNumber,
	          }
	          return this.http.post('/api/getListAllServiceContractExtendHistroy', reqExtendobj).subscribe(
	          res=>{ 
	            let SCExtend = res.json();
	            this.ServiceContractExtend = [];
	            if(SCExtend.length>0) {
	              for(var n=0;n<SCExtend.length;n++) {
	                let SCEobj = {
	                  'serialNumber':SCExtend[n].serialNumber,
	                  'startdate':moment(SCExtend[n].startdate).format("D MMM YYYY"),
	                  'enddate':moment(SCExtend[n].enddate).format("D MMM YYYY"),
	                  'contractExtensionDate':moment(SCExtend[n].contractExtensionDate).format("D MMM YYYY")
	                }
	                this.ServiceContractExtend.push(SCEobj);
	              }
				}
				
				let statusObj = {
					'pmId':this.ListAllHistroyDetails[0].pmId,
					'serialNumber':this.ListAllHistroyDetails[0].serialNumber
				}
				return this.http.post('/api/serviceStatusChecking_serviceFormAPI', statusObj).subscribe(
				res => {
				
					let response = res.json();
					if(response.length > 0) {
						if(response[response.length-1].service_Scheduler_Number == this.ListAllHistroyDetails[0].noOfservice && response[response.length-1].status == 1) {
							this.ListAllHistroyDetails[0].lastServiceStatusOfContract = 'completed';
						} else {
							this.ListAllHistroyDetails[0].lastServiceStatusOfContract = 'notcompleted';
						}
					}
					document.body.scrollTop = 0;
      				document.documentElement.scrollTop = 0;
	            	this.showAlert();
				})
	            
	          })
	          
	        })
	        
	      })
	     
	  }

	close() {
      this.Histroy.hide();
    }

	getCount(){
     if(this.p < Math.ceil(this.listSearchData.length/10)){
       this.startingCount = (this.p-1)*10;
       if(this.startingCount == 0){
         this.startingCount = 1;
       }
       this.endingCount = this.p*10;
     } else if(this.p == Math.ceil(this.listSearchData.length/10)){
       let count = this.listSearchData.length%10;
       this.startingCount = (this.p-1)*10;
       this.endingCount = this.startingCount + count;
       if(this.startingCount == 0){
         this.startingCount = 1;
         this.endingCount = count;
       }
     }
  }

	getAllDetailsFromCustomerMaster () {
		let customerObj = {
			'orgId':this.orgId
		}
		
  		return this.http.post('/api/getCustomerMasterDetails', customerObj).subscribe(
     	res => {
     	
     		this.ListOfCustomerMaster = res.json();
     		for(var i=0;i<this.ListOfCustomerMaster.length;i++) {
     			let obj = {
     				'Id':this.ListOfCustomerMaster[i]._id,
     				'Name':this.ListOfCustomerMaster[i].customer_Name
     			}
     			this.customerDetails.push(obj);
				 }
				 let pusharr=[];
				 for(let i=0;i<this.ListOfCustomerMaster.length;i++){
					pusharr.push({'value':this.ListOfCustomerMaster[i]._id.toString(),'label':this.ListOfCustomerMaster[i].customer_Name.toUpperCase()})
	
				 }
				 this.customerNameDropDown=pusharr;
      	},(err)=>{
      		this.loading=false;
      	})
  	}

  	getAllCheckListMaster() {
  		let checklistmasterObj = {
			'orgId':this.orgId
		}
  		return this.http.post('/api/getCheckListMasterDetails', checklistmasterObj).subscribe(
     	res => {
     		
     		this.ListOfCheckListMaster = res.json();
     	},(err)=>{
     		this.loading=false;
     	})
  	}

  	fromdatechange() {
  		if(this.fromDate == "" || this.fromDate == null || this.fromDate == undefined) {
  			this.errformdate=true;
  		} else{
  			this.errformdate=false;
  		}
  	}
  	toggle() {
  		this.searchBytext = !this.searchBytext;
  	}

	search() {
		this.listSearchData =[];
		this.getAllDetailsFromCustomerMaster ();
		this.getAllCheckListMaster();
		this.getCount();
		this.getAllMakeDetails();
		this.getAllModelDetails();
		this.getAllServiceTypeDetails();
		this.getTechnicianName();
		this.getAllPmaCategorydetails();
		this.loading=true;
		if(this.fromDate == "" || this.fromDate == null || this.fromDate == undefined) {
			this.errformdate=true;
		} else if(this.toDate == "" || this.toDate == null || this.toDate == undefined){
			this.errtodate=true;
		} else {
			let RequiredObj = {
		      'fromDate': moment(this.fromDate).format('YYYY-MM-DD'),
		      'toDate':moment(this.toDate).add(1, 'days').format('YYYY-MM-DD'),
		      'orgId':this.orgId
		    }

		    return this.http.post('/api/getStatusDuereport', RequiredObj).subscribe(
		    res=>{ 
		      this.loading=false;
		      this.Response = res.json();
		      if(this.Response.length>0) {
		      	for (let i=0;i<this.Response[1].pms.length;i++) {
			      	for(var n=0;n<this.Response[0].service.length;n++) {
			      		if(parseInt(this.Response[0].service[n].service_Scheduler_Number) == this.Response[1].pms[i].serviceScheduleDay) {
			      			this.date = this.Response[0].service[n].service_CarriedOut_Date;
			      		}
			      	}
			      	
			      	this.Location = this.Response[1].pms[i].mcLocation;
			      	for(var k=0;k<this.ListAllMake.length;k++) {
			      		if(this.ListAllMake[k]._id == parseInt(this.Response[1].pms[i].make)) {
			      			this.Make = this.ListAllMake[k].make.toUpperCase();
			      		}
			      	}
			      	for(var k=0;k<this.ListAllModel.length;k++) {
			      		if(this.ListAllModel[k]._id == parseInt(this.Response[1].pms[i].model)) {
			      			this.Model = this.ListAllModel[k].model.toUpperCase();
			      		}
							}
							
							for(let k=0;k<this.ListPmaCategoryDetails.length;k++){
								if(this.ListPmaCategoryDetails[k]._id==this.Response[1].pms[i].pmacategory){
                  this.PmaCategoryy=this.ListPmaCategoryDetails[k].pmacategory
								}
							}

			      	for(var k=0;k<this.ListAllServcieType.length;k++) {
			      		if(this.ListAllServcieType[k]._id == parseInt(this.Response[1].pms[i].Servicedetails[this.Response[1].pms[i].serviceScheduleDay - 1].service_Type)) {
			      			this.ServiceType = this.ListAllServcieType[k].servicetype;
			      		}
			      	}
			      	
				

				
					this.MechineSerialNumber = this.Response[1].pms[i].serial_Number;
			      	for(var k =0;k<this.customerDetails.length;k++) {
			      		if( this.Response[1].pms[i].client_Name == this.customerDetails[k].Id){
			      			this.clientId = this.Response[1].pms[i].client_Name;
			      			this.CustomerName = this.customerDetails[k].Name
			      		}
			      	}
			      	
			      	
			      	
			      	
			      	let total =  this.Response[1].pms[i].Servicedetails[this.Response[1].pms[i].serviceScheduleDay - 1].labour_Cost+this.Response[1].pms[i].Servicedetails[this.Response[1].pms[i].serviceScheduleDay - 1].spare_Cost+this.Response[1].pms[i].Servicedetails[this.Response[1].pms[i].serviceScheduleDay - 1].travel_Cost+parseInt(this.Response[1].pms[i].Servicedetails[this.Response[1].pms[i].serviceScheduleDay - 1].consumables);
			      	
			      	let finalObj = {
				      	'date':moment(this.Response[1].pms[i].Servicedetails[this.Response[1].pms[i].serviceScheduleDay - 1].date).format("D MMM YYYY"),
				      	'clientId':this.clientId,
				      	'ClientName':this.CustomerName,
				      	'MCLocation':this.Location,
						'Make':this.Make,
						'PmaCategory':this.PmaCategoryy,
						'id':this.Response[1].pms[i]._id,
				      	'model':this.Model,
				      	'ServiceType':this.ServiceType.toUpperCase(),
				      	'hmr':this.Response[1].pms[i].Servicedetails[this.Response[1].pms[i].serviceScheduleDay - 1].hmr,
				      	'contactreference':this.Response[1].pms[i].contract_Reference,
				      	'contactNumber':this.Response[1].pms[i].phone_Number,
				      	'contractLevel':this.Response[1].pms[i].contractLevel,
				      	'SerialNumber':this.MechineSerialNumber.toString(),
				      	'serviceNumber':this.Response[1].pms[i].serviceScheduleDay,
				      	'Consumables':this.Response[1].pms[i].Servicedetails[this.Response[1].pms[i].serviceScheduleDay - 1].consumables,
				      	'labourCost':this.Response[1].pms[i].Servicedetails[this.Response[1].pms[i].serviceScheduleDay - 1].labour_Cost,
				      	'SparesCost':this.Response[1].pms[i].Servicedetails[this.Response[1].pms[i].serviceScheduleDay - 1].spare_Cost,
				      	'travelCost':this.Response[1].pms[i].Servicedetails[this.Response[1].pms[i].serviceScheduleDay - 1].travel_Cost,
				      	'total':total
				      }
				  
				      this.listSearchData.push(finalObj);
				      this.localArrValue = this.listSearchData;
				      console.log('this.listSearchData '+ this.listSearchData);
			      	this.loading=false;
			      }//main for loop end here
		      } else {
		      	
		      }
		      
		 
		    },(err)=>{
		    	this.loading=false;
		    })//getStatusDuereport end here
		}
	  	
	}

	reset() {
		this.customerName = '';
		this.serialnumber = '';
		this.smake = '';
		this.smodel = '';
		this.CUSTOMERNAMEplaceholder="CUSTOMER NAME",
		this.SERIALNUMBERplaceholder="SERIAL NUMBER";
		this.MAKEplaceholder="MAKE";
		this.MODELplaceholder="MODEL";
		this.search();
	}


	getBranchDetails(){
		let obj={
		 'orgId':this.orgId
		}
		return this.http.post('/api/getbranchdetails',obj).subscribe(res=>{
			 this.ListbranchDetails=res.json();
		})
	 }

	getInfodata() {
		
		this.listSearchData = this.localArrValue;
		let finalArray = [];
		let customer = "";
		let serialNumber="";
		let make="";
		let model=""
		// let customer = this.customerName;
		// let serialNumber = this.serialnumber;
		// let make = this.smake;
		// let model = this.smodel;
		customer = this.customerName;
		for(let i=0;i<this.customerDetails.length;i++){
			if(customer==this.customerDetails[i].Id){
				customer=this.customerDetails [i].Name;
			this.CUSTOMERNAMEplaceholder=customer.toUpperCase();
			}
		}

		serialNumber = this.serialnumber;
		for(let i=0;i<this.ListOfSerialNumber .length;i++){
		 if(serialNumber==this.ListOfSerialNumber[i]._id){
			 serialNumber=this.ListOfSerialNumber[i].serial_Number;
		 this.SERIALNUMBERplaceholder= serialNumber.toUpperCase();
		 }
	 }

	 	make = this.smake;
		 for(let i=0;i<this.ListAllMake.length;i++){
		if(make==this.ListAllMake[i]._id){
			make=this.ListAllMake[i].make.toUpperCase();
		this.MAKEplaceholder=make.toUpperCase();
		}
 	}

	 	model = this.smodel;
		for(let i=0;i<this.ListAllModel.length;i++){
			if(model==this.ListAllModel[i]._id){
			model=this.ListAllModel[i].model.toUpperCase();
				this.MODELplaceholder=model.toUpperCase();
			}
		 }

		//  for(let i=0;i<this.listSearchData.length;i++){
		// 	if(this.listSearchData[i].Make==this.listSearchData[i].Make.toUpperCase()||this.listSearchData[i].model==this.listSearchData[i].model.toUpperCase()){
		// 		if(make==undefined||make==""){
		// 			console.log("######################make")
		// 		}else{
		// 			make=make.toUpperCase();
		// 		}
		// 		if(model==undefined||model==""){
		// 		console.log("######################model")
		// 		}else{
		// 			model=model.toUpperCase();
		// 		}
				
		// 	}
		// }


		if(customer !== undefined && (serialNumber == undefined || serialNumber == '' || serialNumber == null) && (make == undefined || make == '' || make == null) && (model == undefined  || model == ''  || model == null)) {
			for(let i=0;i<this.listSearchData.length;i++) {
				if(this.listSearchData[i].ClientName == customer) {
					finalArray.push(this.listSearchData[i]); 
				}

			}
			this.listSearchData = []
			this.listSearchData = finalArray;
          
        } else if(serialNumber !== undefined && (customer == undefined || customer == '' || customer == null) && (make == undefined || make == '' || make == null) && (model == undefined  || model == ''  || model == null)) {
        	for(let i=0;i<this.listSearchData.length;i++) {
				if(this.listSearchData[i].SerialNumber == serialNumber) {
					finalArray.push(this.listSearchData[i]); 
				}

			}
			this.listSearchData = []
			this.listSearchData = finalArray;
          //obj = {'serial_Number':serialNumber,'orgId':req.body.orgId};
        }  else if(make !== undefined && (serialNumber == undefined || serialNumber == '' || serialNumber == null) && (customer == undefined || customer == '' || customer == null) && (model == undefined  || model == ''  || model == null)) {
        	for(let i=0;i<this.listSearchData.length;i++) {
				if(this.listSearchData[i].Make.toUpperCase() == make) {
					finalArray.push(this.listSearchData[i]); 
				}

			}
			this.listSearchData = []
			this.listSearchData = finalArray;
          //obj = {'make':make,'orgId':req.body.orgId};
        } else if(model !== undefined && (serialNumber == undefined || serialNumber == '' || serialNumber == null) && (customer == undefined || customer == '' || customer == null) && (make == undefined || make == '' || make == null)) {
        	for(let i=0;i<this.listSearchData.length;i++) {
				if(this.listSearchData[i].model.toUpperCase() == model) {
					finalArray.push(this.listSearchData[i]); 
				}

			}
			this.listSearchData = []
			this.listSearchData = finalArray;
          //obj = {'model':model,'orgId':req.body.orgId};
        } else if(customer !== undefined && serialNumber !== undefined &&  (model == undefined  || model == ''  || model == null) && (make == undefined || make == '' || make == null)) {
        	for(let i=0;i<this.listSearchData.length;i++) {
				if(this.listSearchData[i].ClientName == customer && this.listSearchData[i].SerialNumber == serialNumber) {
					finalArray.push(this.listSearchData[i]); 
				}

			}
			this.listSearchData = []
			this.listSearchData = finalArray;
          //obj = {'client_Name':customer,'serial_Number':serialNumber,'orgId':req.body.orgId};
        } else if(customer !== undefined && make !== undefined &&  (model == undefined  || model == ''  || model == null) && (serialNumber == undefined || serialNumber == '' || serialNumber == null)) {
        	for(let i=0;i<this.listSearchData.length;i++) {
				if(this.listSearchData[i].ClientName == customer && this.listSearchData[i].Make == make) {
					finalArray.push(this.listSearchData[i]); 
				}

			}
			this.listSearchData = []
			this.listSearchData = finalArray;
          //obj = {'client_Name':customer,'make':make,'orgId':req.body.orgId};
        } else if(customer !== undefined && model !== undefined && (make == undefined || make == '' || make == null)  && (serialNumber == undefined || serialNumber == '' || serialNumber == null)) {
        	for(let i=0;i<this.listSearchData.length;i++) {
				if(this.listSearchData[i].ClientName == customer && this.listSearchData[i].model == model) {
					finalArray.push(this.listSearchData[i]); 
				}

			}
			this.listSearchData = []
			this.listSearchData = finalArray;
          //obj = {'client_Name':customer,'model':model,'orgId':req.body.orgId};
        } else if(serialNumber !== undefined && make !== undefined && (model == undefined  || model == ''  || model == null)  && (customer == undefined || customer == '' || customer == null)) {
        	for(let i=0;i<this.listSearchData.length;i++) {
				if(this.listSearchData[i].SerialNumber == serialNumber && this.listSearchData[i].Make == make) {
					finalArray.push(this.listSearchData[i]); 
				}

			}
			this.listSearchData = []
			this.listSearchData = finalArray;
          //obj = {'serial_Number':serialNumber,'make':make,'orgId':req.body.orgId};
        } else if(serialNumber !== undefined && model !== undefined && (make == undefined || make == '' || make == null)  && (customer == undefined || customer == '' || customer == null)) {
        	for(let i=0;i<this.listSearchData.length;i++) {
				if(this.listSearchData[i].SerialNumber == serialNumber && this.listSearchData[i].model == model) {
					finalArray.push(this.listSearchData[i]); 
				}

			}
			this.listSearchData = []
			this.listSearchData = finalArray;
          //obj = {'serial_Number':serialNumber,'model':model,'orgId':req.body.orgId};
        } else if(make !== undefined && model !== undefined && (serialNumber == undefined || serialNumber == '' || serialNumber == null)  && (customer == undefined || customer == '' || customer == null)) {
        	for(let i=0;i<this.listSearchData.length;i++) {
				if(this.listSearchData[i].Make == make && this.listSearchData[i].model == model) {
					finalArray.push(this.listSearchData[i]); 
				}

			}
			this.listSearchData = []
			this.listSearchData = finalArray;
          //obj = {'make':make,'model':model,'orgId':req.body.orgId};
        } else if(customer !== undefined && serialNumber !== undefined && make !== undefined && (model == undefined  || model == ''  || model == null)) {
        	for(let i=0;i<this.listSearchData.length;i++) {
				if(this.listSearchData[i].ClientName == customer && this.listSearchData[i].SerialNumber == serialNumber && this.listSearchData[i].Make == make) {
					finalArray.push(this.listSearchData[i]); 
				}

			}
			this.listSearchData = []
			this.listSearchData = finalArray;
          //obj = {'client_Name':customer,'serial_Number':serialNumber,'make':make,'orgId':req.body.orgId};
        } else if(customer !== undefined && make !== undefined && model !== undefined && (model == undefined  || model == ''  || model == null)) {
        	for(let i=0;i<this.listSearchData.length;i++) {
				if(this.listSearchData[i].ClientName == customer && this.listSearchData[i].model == model && this.listSearchData[i].Make == make) {
					finalArray.push(this.listSearchData[i]); 
				}

			}
			this.listSearchData = []
			this.listSearchData = finalArray;
          //obj = {'client_Name':customer,'make':make,'model':model,'orgId':req.body.orgId};
        } else if(serialNumber !== undefined &&  make !== undefined && model !== undefined && (customer == undefined || customer == '' || customer == null)) {
        	for(let i=0;i<this.listSearchData.length;i++) {
				if(this.listSearchData[i].SerialNumber == serialNumber && this.listSearchData[i].model == model && this.listSearchData[i].Make == make) {
					finalArray.push(this.listSearchData[i]); 
				}

			}
			this.listSearchData = []
			this.listSearchData = finalArray;
         // obj = {'serial_Number':serialNumber,'make':make,'model':model,'orgId':req.body.orgId};
        } else if(customer !== undefined && serialNumber !== undefined && model !== undefined && (make == undefined || make == '' || make == null)) {
        	for(let i=0;i<this.listSearchData.length;i++) {
				if(this.listSearchData[i].ClientName == customer && this.listSearchData[i].SerialNumber == serialNumber && this.listSearchData[i].model == model) {
					finalArray.push(this.listSearchData[i]); 
				}

			}
			this.listSearchData = []
			this.listSearchData = finalArray;
          //obj = {'client_Name':customer,'serial_Number':serialNumber,'model':model,'orgId':req.body.orgId};
        } else if(customer !== undefined && serialNumber !== undefined && make !== undefined && model !== undefined) {
        	for(let i=0;i<this.listSearchData.length;i++) {
				if(this.listSearchData[i].ClientName == customer && this.listSearchData[i].SerialNumber == serialNumber && this.listSearchData[i].Make == make) {
					finalArray.push(this.listSearchData[i]); 
				}

			}
			this.listSearchData = []
			this.listSearchData = finalArray;
          //obj = {'client_Name':customer,'serial_Number':serialNumber,'make':make,'model':model,'orgId':req.body.orgId};
        } else if(customer === undefined && serialNumber === undefined && make === undefined && model === undefined) {
        	alert('Please select any option from customer Name, Serial Number, Make or Model');
        }

	}

}



// WEBPACK FOOTER //
// ./client/app/service-due-report/service-due-report.component.ts